import axios from 'axios';
import FormData from 'form-data';
import { getItem } from '../../utility/localStorageControl';

const API_ENDPOINT = `${process.env.REACT_APP_YERBIS_TEST_APP_API_ENDPOINT}`;

const contentType = (useJSONInBody = false) => ({
  'Content-Type': useJSONInBody ? 'application/json' : 'multipart/form-data',
});

const client = axios.create({
  baseURL: API_ENDPOINT,
});

class DataService {
  static async post(path = '', data = {}, optionalHeader = {}, useJSONInBody = false) {
    return client({
      method: 'POST',
      url: path,
      data: useJSONInBody ? data : this.getFormData(data),
      headers: { ...optionalHeader, ...contentType(useJSONInBody) },
    });
  }

  static getFormData(data = {}) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    return formData;
  }
}

client.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem('access_token');
  if (accessToken) {
    config.headers.token = accessToken;
  }

  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    const originalRequest = error.config;
    if (response) {
      if (response.status === 500) {
        // boş
      } else if (response.status === 400) {
        return response;
      } else {
        return originalRequest;
      }
    }
    return Promise.reject(error);
  },
);
export { DataService };
